"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var config_provider_1 = require("../../../config-provider");
var ConfirmDialog_1 = tslib_1.__importDefault(require("../ConfirmDialog"));
// interface ModalLocale {
//   okText: string;
//   cancelText: string;
//   justOkText: string;
// }
var HookModal = function (_a, ref) {
    var afterClose = _a.afterClose, config = _a.config;
    var _b = tslib_1.__read(React.useState(true), 2), visible = _b[0], setVisible = _b[1];
    var _c = tslib_1.__read(React.useState(config), 2), innerConfig = _c[0], setInnerConfig = _c[1];
    var _d = React.useContext(config_provider_1.ConfigContext), direction = _d.direction, getPrefixCls = _d.getPrefixCls;
    var prefixCls = getPrefixCls('modal');
    var rootPrefixCls = getPrefixCls();
    function close() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        setVisible(false);
        var triggerCancel = args.some(function (param) { return param && param.triggerCancel; });
        if (innerConfig.onCancel && triggerCancel) {
            innerConfig.onCancel();
        }
    }
    React.useImperativeHandle(ref, function () { return ({
        destroy: close,
        update: function (newConfig) {
            setInnerConfig(function (originConfig) { return (tslib_1.__assign(tslib_1.__assign({}, originConfig), newConfig)); });
        },
    }); });
    return (React.createElement(React.Fragment, null, function () { return (React.createElement(ConfirmDialog_1.default, tslib_1.__assign({ prefixCls: prefixCls, rootPrefixCls: rootPrefixCls }, innerConfig, { close: close, visible: visible, afterClose: afterClose, okText: innerConfig.okText || '确认', direction: direction, cancelText: innerConfig.cancelText || '取消' }))); }));
};
exports.default = React.forwardRef(HookModal);
//# sourceMappingURL=HookModal.js.map